import * as React from 'react'
import {GatsbyImage, getImage, ImageDataLike} from "gatsby-plugin-image";
import isBrowser from 'services/isBrowser';

export const Gallery = ({ galleryPhotos}: {galleryPhotos: ImageDataLike[]}) => {
  const [imagePopUpOpen, setImagePopUpOpen] = React.useState(false)
  const [modalWasOpen, setModalWasOpen] = React.useState(false)
  const [clickedImageData, setClickedImageData] = React.useState(null)
  const scrollRef = React.useRef(null)


  const showImageModal = (gatsbyImageData: any) => {
    setImagePopUpOpen(prev => !prev)
    setClickedImageData(gatsbyImageData)
    setTimeout(() => { if (isBrowser()) window.scrollTo(0, 0) }, 1)
    setModalWasOpen(true)
  }
  const closeImageModal = () => {
    setImagePopUpOpen(false)
    setClickedImageData(null)
  }
  React.useEffect(()=>{
    if(imagePopUpOpen) {
      document.body.classList.add('disable--scroll')
    }
    if(!imagePopUpOpen && modalWasOpen) {
        document.body.classList.remove('disable--scroll')
        if (isBrowser()) {
            window.scrollTo(0, (scrollRef.current.offsetTop - 250),)
        }
    }
  }, [imagePopUpOpen, modalWasOpen])


    return <div className="destination__gallery" ref={scrollRef}>
      <div className="row row--ng">
            {galleryPhotos.map((image, index) => <div className={`col ${getNumberOfColumns(galleryPhotos.length)} col--ng destination__gallery--max-height`} key={index}>
              <GatsbyImage loading='lazy' alt='' image={getImage(image)} className="image--fit_cover destination__gallery__image" />
            </div>)}
    </div>
      {/* { imagePopUpOpen && <div className="gallery__modal center" onClick={closeImageModal}>
              <div className="gallery__modal__overlay"/>

                  <GatsbyImage alt={''} image={clickedImageData} className="gallery__modal__image"/>
            </div>
      } */}
    </div>

}


const getNumberOfColumns = (numberOfPhotos: number) => {
  if(numberOfPhotos === 1) {
    return "col--is--12"
  }
  if(numberOfPhotos === 2) {
    return "col--sm--6 col--is--12"
  }
    if (numberOfPhotos === 3 || numberOfPhotos % 3 === 0) {
    return "col--xl--4 col--sm--6 col--is--12"
    }
    if (numberOfPhotos % 2 === 0) {
        return "col--sm--6 col--is--12"
    }
  
}